import { CHANGE_THEME } from "./actionTypes"

const initialState = {
  mode: localStorage.getItem("theme") || "light", 
}

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_THEME:
      localStorage.setItem("theme", action.payload) // persist
      return { ...state, mode: action.payload }
    default:
      return state
  }
}

export default themeReducer
